<template>
  <div class="card-container position-relative">
    <div class="link">
      <a-button @click="openQrcode()">{{ $t('page_ops_customer_reporting_qr_code') }}</a-button>
      <a-button v-acl="'page_ops_customer_machine_config'" style="margin-left: 8px" @click="opendownpdf">
        {{ $t('page_ops_customer_machine_config') }}
      </a-button>
    </div>
    <a-tabs v-model="tabIndex" class="height-100">
      <a-tab-pane :tab="$t('page_ops_customer_statistics')" key="1">
        <div style="width: 100%">
          <div
            class="flex"
            style="padding-right: 24px; justify-content: space-between; align-items: center"
          >
            <div class="oee-timechart-title">
              {{ $t('page_ops_customer_current_day_tool') }}
            </div>
            <a-button style="cursor: pointer" @click="refreshStatus">
              {{ $t('page_ops_customer_refresh') }}
            </a-button>
          </div>
          <TimeChart
            v-if="dataValue"
            :columns="dataColumns"
            :dataValue="dataValue"
            :color="color"
            style="height: 100px; width: 100%"
          ></TimeChart>
          <div v-else>
            <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" />
          </div>
        </div>
        <div class="oee-linechart-box">
          <div class="flex justify-content-space-between">
            <a-radio-group :value="oeeOption" button-style="solid" @change="changeSearchDay">
              <a-radio-button value="1">
                {{ $t('page_ops_customer_daily_crop_rate') }}
              </a-radio-button>
              <a-radio-button value="7">
                {{ $t('page_ops_customer_recent_7_days') }}
              </a-radio-button>
              <a-radio-button value="30">
                {{ $t('page_ops_customer_recent_one_month') }}
              </a-radio-button>
            </a-radio-group>
          </div>
          <line-chart
            v-if="lineChartOption.seriesData && lineChartOption.seriesData.length"
            :dataValue="lineChartOption.axisData"
            :columns="lineChartOption.seriesData"
            :deviceName="device.name"
            :color="color"
            :oeeOption="oeeOption"
            :tabIndex="tabIndex"
            class="flex-1"
          ></line-chart>
          <div v-else class="empty-center">
            <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane class="tab1" :tab="$t('page_ops_customer_real_time')" key="2">
        <real-time v-show="tabIndex === '2'" :device="device"></real-time>
      </a-tab-pane>
      <a-tab-pane :tab="$t('page_ops_customer_program_transfer')" key="3">
        <program-transfer v-if="tabIndex === '3'" :device="device"></program-transfer>
      </a-tab-pane>
    </a-tabs>
    <download-property
      :device="device"
      :show="showDownload"
      @update="showDownload = false"
    ></download-property>
  </div>
</template>
<script>
import LineChart from './LineChart'
import TimeChart from './TimeChart'
import RealTime from './RealTime'
import DownloadProperty from './DownloadProperty'
import ProgramTransfer from './ProgramTransfer.vue'
import dayjs from 'dayjs'
import { Empty } from 'ant-design-vue'
import { StatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import { WorkStationIotServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'

const stsp = new StatisticsServiceProxy()
const wssp = new WorkStationIotServiceProxy()

export default {
  components: {
    LineChart,
    TimeChart,
    RealTime,
    DownloadProperty,
    ProgramTransfer
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    statusData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dataColumns() {
      return this.statusData.collectStatusInfo
    },
    dataValue() {
      return this.statusData.items
    },
    color() {
      return [
        '#37A2DA',
        '#32C5E9',
        '#67E0E3',
        '#9FE6B8',
        '#FFDB5C',
        '#ff9f7f',
        '#fb7293',
        '#E062AE',
        '#E690D1',
        '#e7bcf3',
        '#9d96f5',
        '#8378EA',
        '#96BFFF'
      ]
    }
  },
  watch: {
    device: {
      handler() {
        if (this.device.id) {
          this.getOeeData()
        } else {
          this.lineChartOption = { axisData: {}, seriesData: [] }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      tabIndex: '1',
      oeeOption: '1',
      lineChartOption: { axisData: {}, seriesData: [] }, // 机床稼动率图表数据
      dataOption: [], // 设备实时状态图表数据
      showDownload: false,
      Empty
    }
  },
  methods: {
    changeSearchDay(value) {
      this.oeeOption = value.target.value
      this.getOeeData()
    },
    refreshStatus() {
      this.$emit('refreshStatus')
    },
    // 打开二维码
    async openQrcode() {
      if (typeof this.device.id === 'undefined') {
        return
      }
      const data = await wssp.getWorkStationIot(this.device.id)
      if (data.length) {
        const { iotCode } = data[0]
        const weChatAppletMap = {
          'masterlink': 'cloud-7gcft4p72daa8f48-1313341508.tcloudbaseapp.com', 
          'makino': 'cloud-6go60bz547dfafad-1308944524.tcloudbaseapp.com'
        }
        const type = window.location.href.includes('makino.cloud') ? 'makino' : 'masterlink';
        window.open(
          `https://cli.im/api/qrcode/code?text=https://${weChatAppletMap[type]}?gatewayCode=${iotCode}&mhid=thfDDlzvyMwhMHcpLNdcO64`
        )
      }
    },
    opendownpdf() {
      this.showDownload = true
    },
    getOeeData() {
      this.lineChartOption = { axisData: {}, seriesData: [] }
      const startDate = dayjs().subtract(Number(this.oeeOption), 'day').format('YYYY-MM-DD')
      const devices = {
        key: this.device.id,
        name: this.device.name,
        code: this.device.code,
        standardEfficiency: null
      }
      if (devices.key != undefined) {
        if (this.oeeOption == 1) {
          const param = {
            factoryDate: dayjs().format('YYYY-MM-DD'),
            workStationId: this.device.id
          }

          stsp.productivityAnalysisHourRps(param).then((res) => {
            this.lineChartOption = {
              axisData: res.data,
              seriesData:
                res.columns && res.columns.length
                  ? res.columns.map((x) => ({ code: x, title: x }))
                  : []
            }
          })
        } else {
          const param = {
            endDate: dayjs().format('YYYY-MM-DD'),
            productivityType: 'OEE',
            shiftList: [],
            showType: 1,
            startDate: startDate,
            statisticalMethod: 2,
            workStationList: [devices]
          }
          stsp.operationStatisticsRps(param).then((res) => {
            const { items, columns } = res

            if (items.length === 0) {
              this.lineChartOption = { axisData: {}, seriesData: [] }
              return
            }

            for (const column of columns) {
              for (const item of items) {
                if (!item.data) item.data = {}
                if (!item.data.hasOwnProperty(column.code)) {
                  item.data[column.code] = 0
                }
              }
            }
            this.lineChartOption = {
              axisData: items[0].data,
              seriesData: columns
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
@theme-margin: 16px;
.card-container {
  width: calc(100% - 500px);
  height: 100%;
  border-left: 1px solid #d7d7d7;
  padding-left: 8px;
}
.btn-group {
  margin-bottom: @theme-margin;

  button {
    min-width: 88px;
    padding: 0 16px;
    margin-right: @theme-margin;
  }
}

.man-con {
  display: flex;
  width: 100%;
  height: calc(100% - 48px);

  .right {
    margin-left: @theme-margin;
    width: calc(100% - 310px - @theme-margin);
    height: 100%;
  }
}

.tree {
  width: 310px;
  height: 100%;
  background: #fff;
  overflow: auto;
  /*box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);*/
}

.height-100 {
  height: 100%;
  box-shadow: none;
}

.oee-linechart-box {
  border: 1px solid #d8d8d8;
  background-color: #f8f8f8;
  padding: 8px;
  margin-top: 8px;
  height: calc(100% - 155px);
}
.oee-timechart-title {
  border-left: 3px solid #3a7fbc;
  padding-left: 8px;
  color: #3a7fbc;
  font-weight: bold;
}

.empty-center {
  height: calc(100% - 32px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .ant-tabs-bar {
  margin: 0 0 8px 0;
}
/deep/ .ant-empty-normal {
  margin: 18px 0;
}
</style>
